import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import type { Bootstrap } from './types.js';
const initial: Bootstrap = JSON.parse(document.getElementById('bootstrap')!.textContent!);
const root = document.getElementById('root')!;
const app = (
  <BrowserRouter>
    <App initial={initial} />
  </BrowserRouter>
);
if (initial.admin) createRoot(root).render(app);
else hydrateRoot(root, app);
